var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"contact",class:{ hidden: _vm.isActive },on:{"click":function($event){return _vm.toggle()}}},[_c('span',[_vm._v("お問い合わせはこちら")])])}
var staticRenderFns = []

export { render, staticRenderFns }